export Create from './create/create';
export Onboarding from './onboarding/onboarding';
export Gallery from './gallery/gallery';
export HeatMap from './heat-map/heat-map';
export ProjectSummary from './create/project-summary';
export Tutorial from './create/tutorial/tutorial';
export Brief from './create/steps/brief';
export Targeting from './create/steps/targeting';



// WEBPACK FOOTER //
// ./src/components/projects/index.js